import React, { useEffect } from 'react';
import { db } from '../../services/firebase/config';
import { getDocs, collection } from 'firebase/firestore'
import useToursStore from '../../store/tournamentsStore';
import useNewsStore from '../../store/newsStore';
import useProRatingStore from '../../store/proRatingStore';

const Preloader = () => {

    return (
        <div className="theme-loader">
            <div className="spinner">
                <div className="double-bounce1"></div>
                <div className="double-bounce2"></div>
            </div>
        </div>
    );
};

export default Preloader;